module.exports = __webpack_public_path__ + "img/scene_5.3d58c057.png";